import { rem, rgba } from 'polished';
import styled from 'styled-components/macro';

export const StyledHeader = styled.header`
  padding: 0 2%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.main};
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: ${rem('72px')};
    width: 100%;
    z-index: 10;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 0 25.2%;
    padding-top: ${rem('74px')};
    box-shadow: ${({ theme }) =>
      `0 0 ${rem('8px')} ${rgba(theme.colors.cross.silverFox, 0.5)}`};
    clip-path: ${`inset(0px ${rem('-8px')} 0px 0px)`};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    flex-basis: 19.7%;
  }
`;

export const StyledMobileNavMenuWrapper = styled.section`
  position: absolute;
  width: 100vw;
  height: calc(100vh - ${rem('72px')});
  top: ${rem('72px')};
  left: 0;
  background-color: ${({ theme }) => theme.colors.main};
`;
